"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValue = exports.getAxisMinMaxValues = void 0;
var numeral = require("numeral");
exports.getAxisMinMaxValues = function (maxValue, minValue, valueType) {
    if (valueType && valueType.toLowerCase() !== 'percentage') {
        return { yAxisMax: maxValue, yAxisMin: minValue };
    }
    var yAxisMax = Math.max(getAxisMaxValue(maxValue), 0);
    var yAxisMin = Math.min(getAxisMaxValue(minValue), 0);
    if (yAxisMax !== 0 && yAxisMin !== 0) {
        var max = Math.max(Math.abs(yAxisMax), Math.abs(yAxisMin));
        return { yAxisMax: max, yAxisMin: -max };
    }
    return { yAxisMax: yAxisMax, yAxisMin: yAxisMin };
};
var getAxisMaxValue = function (value) {
    var sign = value >= 0 ? 1 : -1;
    var counter = 0.05;
    var step = 0.05;
    value = Math.abs(value);
    while (counter <= value) {
        counter += step;
        step = 0.1;
    }
    return counter * sign;
};
exports.formatValue = function (value, valueType, currency) {
    var formattedValue = '';
    if (valueType && valueType.toLowerCase() === 'currency') {
        formattedValue = "" + currency + numeral(value)
            .format('0.0a')
            .toUpperCase();
    }
    else if (valueType && valueType.toLowerCase() === 'percentage') {
        formattedValue = Math.floor(value * 1000) / 10 + "%";
    }
    else {
        formattedValue = "" + Math.floor(value * 100) / 100;
    }
    return formattedValue;
};
//# sourceMappingURL=ApWidgetChart.utils.js.map